import React, { Component } from "react";
import axios from "axios";
//@ts-ignore
import { NumberInput } from "../components/NumberInput.tsx";
//@ts-ignore
import { ErrorBox } from "../components/ErrorBox.tsx";
//@ts-ignore
import { TermSelect } from "../components/TermSelect.tsx";
//@ts-ignore
import {
  IRepaymentCalculationRequest,
  ICalculationResult,
  ILenderProduct,
  ProductCategory,
} from "../helpers/Models.tsx";
//@ts-ignore
import { NumberAsCurrency } from "../components/NumberAsCurrency.tsx";
import { LenderRow } from "../components/LenderRow.tsx";
import { GetStartedButton } from "../components/GetStartedButton.tsx";
import { BerSelect } from "../components/BerSelect.tsx";

interface IProps {
  gtmEvent(): void;
  nextStep(response: string, loadJourney: boolean): void;
  updateLead(props: any): void;
  homeValue?: number;
  mortgageAmountRequired?: number;
  term?: number;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  homeValue: number | null | undefined;
  mortgageAmountRequired: number | null | undefined;
  term: number | null | undefined;
  showResult: boolean;
  calculationResult?: ICalculationResult;
  ber: string | null;
}

export class PurchasingCalculator extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.calculateRepayments = this.calculateRepayments.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.state = {
      hasError: false,
      showResult: false,
      homeValue: this.props.homeValue ?? null,
      mortgageAmountRequired: this.props.mortgageAmountRequired ?? null,
      term: this.props.term ?? 25,
      ber: null,
    };
  }

  componentDidMount(): void {
    this.props.gtmEvent();
    if (!this.props.term) this.props.updateLead({ remainingTerm: 25 });
  }

  calculateRepaymentsDelayed() {
    setTimeout(this.calculateRepayments, 500);
  }

  calculateRepayments() {
    var homeValue = this.state.homeValue;
    var mortgageAmountRequired = this.state.mortgageAmountRequired;
    var term = this.state.term;
    var errors: string[] = [];
    var ber = this.state.ber;
    if (!homeValue || !mortgageAmountRequired || !term) {
      return;
    }

    if (mortgageAmountRequired / homeValue > 0.9) {
      errors.push(
        "Mortgage amount required cannot be greater than 90% of the expected purchase price"
      );
      //this.setState({errors: errors, hasError: true, showResult: false, mortgageAmountRequired: Math.round(this.state.homeValue * 0.9)});
      this.setState({ errors: errors, hasError: true, showResult: false });
      return;
    }
    this.setState({ errors: [], hasError: false });

    var request: IRepaymentCalculationRequest = {
      purchasePrice: homeValue,
      mortgageAmount: mortgageAmountRequired,
      term: term,
      ber: ber,
    };
    axios
      .post("/calculator/CalculateRepayment", request)
      .then((response) => {
        var showResults = response.data.products.length > 0;
        this.setState({
          showResult: showResults,
          calculationResult: response.data,
        });
      })
      .catch((error) => {
        //alert('submit error: ' + error.message);
      });
    // this.setState({checking: true});
  }

  nextStep() {
    var errors: string[] = [];
    if (
      !this.state.homeValue ||
      !this.state.mortgageAmountRequired ||
      !this.state.term
    ) {
      if (!this.state.homeValue) {
        errors.push("Home Value is required");
      }
      if (!this.state.mortgageAmountRequired) {
        errors.push("Mortgage Amount is required");
      }
      if (!this.state.term) {
        errors.push("Term is required");
      }
      this.setState({ errors: errors, hasError: true });
      return;
    }
    this.props.nextStep("Repayment Calculator", true);
  }

  fixedYearText(product: ILenderProduct): any {
    var rateText = "";
    if (!product) return "";
    if (product.fixedYears > 0) {
      rateText = `${product.fixedYears} year, ${product.type}`;
      if (rateText.endsWith("rate")) {
        rateText = rateText.replace("rate", "");
      }
    } else {
      rateText = product.type;
    }
    return rateText;
  }

  render() {
    return (
      <header className="App-header">
        {/* <h1 className='l'>Switching Calculator</h1>
                <p>Let's talk numbers. Simply add your details to see how much you could save each month.</p>
                <br /> */}
        <div className="wrapper">
          {/* <div className="row"> */}
          <div className="row row-mobile">
            <div className="column2">
              <NumberInput
                id="homeValue"
                key="homeValue"
                label={
                  <>
                    Expected <strong>Purchase Price</strong>
                  </>
                }
                value={this.props.homeValue}
                classes={`${
                  this.state.hasError && !this.state.homeValue ? "e" : ""
                } ps-1 brightinput`}
                onChange={(e) => {
                  this.setState({ homeValue: e.target.value });
                  this.props.updateLead({
                    mortgageType: "purchaser",
                    homeValue: e.target.value,
                  });
                }}
                onBlur={this.calculateRepaymentsDelayed}
              />
            </div>
            <div className="column2">
              <NumberInput
                id="homeValue"
                key="homeValue"
                label={
                  <>
                    <strong>Mortgage Amount</strong> Required
                  </>
                }
                value={this.props.homeValue}
                classes={`${
                  this.state.hasError && !this.state.homeValue ? "e" : ""
                } ps-1 brightinput`}
                onChange={(e) => {
                  this.setState({ mortgageAmountRequired: e.target.value });
                  this.props.updateLead({
                    mortgageType: "purchaser",
                    mortgageAmountRequired: e.target.value,
                  });
                }}
                onBlur={this.calculateRepaymentsDelayed}
              />
            </div>
          </div>
          <div className="row row-mobile">
            <div className="column2">
              <TermSelect
                label={
                  <>
                    <strong>Term</strong> of your mortgage
                  </>
                }
                selectedterm={this.props.term}
                classes="brightinput"
                onChange={(e) => {
                  this.setState({ term: +e.target.value });
                  this.props.updateLead({
                    mortgageType: "purchaser",
                    remainingTerm: +e.target.value,
                  });
                }}
                onBlur={this.calculateRepaymentsDelayed}
              />
            </div>
            <div className="column2">
              <BerSelect
                label={
                  <>
                    <strong>BER</strong> rating
                  </>
                }
                onChange={(e) => {
                  this.setState({ ber: e.target.value });
                  this.props.updateLead({
                    mortgageType: "switcher",
                    ber: e.target.value,
                  });
                  this.calculateRepaymentsDelayed();
                }}
              />
            </div>
          </div>
          {this.state.hasError && (
            <ErrorBox hideTitle={true} errors={this.state.errors!} />
          )}
          {!this.state.showResult && (
            <div className="row mt-2">
              <LenderRow showDisclaimer={true} />
            </div>
          )}
          {this.state.showResult && (
            <div className="box chartreuse mt-2">
              <div className="row">
                <h2>
                  Lowest market rates available to you today based on your
                  mortgage amount and loan to value.
                </h2>
                <p>
                  {this.state.calculationResult &&
                    this.state.calculationResult.cashback > 0 && (
                      <>
                        Up to{" "}
                        <NumberAsCurrency
                          value={this.state.calculationResult.cashback}
                        />{" "}
                        cashback available on your mortgage level
                      </>
                    )}
                </p>
                <div className="row">
                  <div className="column">
                    {this.state.calculationResult && (
                      <GetStartedButton onClick={() => this.nextStep()} />
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="repayment-table">
                  {this.state.calculationResult?.products.map(
                    (item: ILenderProduct, index: number) => {
                      if (index === 0) {
                        return (
                          <>
                            <div className="firstrow">
                              <div
                                className="first cell"
                                style={{ display: "block" }}
                              >
                                {/* <p>&nbsp;</p> */}
                                <div className="row mt-0 mb-0">
                                  {item.lenderLogo ? (
                                    <img
                                      className=""
                                      style={{
                                        height: "50px",
                                        marginTop: -5,
                                      }}
                                      src={item.lenderLogo}
                                    ></img>
                                  ) : (
                                    <h1>{item.lenderName}</h1>
                                  )}
                                </div>

                                <h2 className="mt-0">
                                  {this.state.calculationResult && (
                                    <>{this.fixedYearText(item)}</>
                                  )}
                                </h2>
                                {item.cashbackAmount && (
                                  <p className="s impact">
                                    Cashback{" "}
                                    <NumberAsCurrency
                                      value={item.cashbackAmount}
                                    />
                                  </p>
                                )}
                                {item.minBerText &&
                                  item.minBerText !== "ZZ" && (
                                    <>
                                      <p className="s impact">
                                        Min BER {item.minBerText}
                                      </p>
                                    </>
                                  )}
                              </div>
                              <div
                                className="middle cell"
                                style={{ display: "block" }}
                              >
                                <p>Monthly repayment</p>
                                <h1>
                                  {this.state.calculationResult && (
                                    <NumberAsCurrency
                                      value={
                                        this.state.calculationResult.repayment
                                      }
                                    />
                                  )}
                                </h1>
                              </div>
                              <div
                                className="last cell"
                                style={{ display: "block" }}
                              >
                                <p>Rate</p>
                                <h1>
                                  {this.state.calculationResult &&
                                    item.rate + "%"}
                                </h1>
                              </div>
                            </div>
                          </>
                        );
                      }
                      if (
                        index ===
                        this.state.calculationResult!.products.length - 1
                      ) {
                        return (
                          <>
                            <div className="lastrow">
                              <div className="first cell">
                                <div className="mt-0 mb-0">
                                  {item.lenderLogo ? (
                                    <img
                                      className=""
                                      style={{
                                        height: "50px",
                                      }}
                                      src={item.lenderLogo}
                                    ></img>
                                  ) : (
                                    <h1>{item.lenderName}</h1>
                                  )}
                                  <div>
                                    <p>
                                      {this.state.calculationResult &&
                                        this.fixedYearText(item)}
                                    </p>
                                    {item.cashbackAmount && (
                                      <p className="s impact">
                                        Cashback{" "}
                                        <NumberAsCurrency
                                          value={item.cashbackAmount}
                                        />
                                      </p>
                                    )}
                                    {item.category ===
                                      ProductCategory.Green && (
                                      <>
                                        <p className="s impact">
                                          Min BER {item.minBerText}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="middle cell">
                                <p>
                                  <span className="l">
                                    {this.state.calculationResult && (
                                      <NumberAsCurrency
                                        value={item.repayment}
                                      />
                                    )}
                                  </span>
                                </p>
                              </div>
                              <div className="last cell">
                                <p>
                                  {this.state.calculationResult &&
                                    item.rate + "%"}
                                </p>
                              </div>
                            </div>
                          </>
                        );
                      }
                      return (
                        <>
                          <div className="middlerow">
                            <div className="d-flex flex-column first cell">
                              <div className="mt-0 mb-0">
                                {item.lenderLogo ? (
                                  <img
                                    className=""
                                    style={{
                                      height: "50px",
                                    }}
                                    src={item.lenderLogo}
                                  ></img>
                                ) : (
                                  <h1>{item.lenderName}</h1>
                                )}
                                <div>
                                  <p>
                                    {this.state.calculationResult &&
                                      this.fixedYearText(item)}
                                  </p>
                                  {item.cashbackAmount && (
                                    <p className="s impact">
                                      Cashback{" "}
                                      <NumberAsCurrency
                                        value={item.cashbackAmount}
                                      />
                                    </p>
                                  )}
                                  {item.category === ProductCategory.Green && (
                                    <>
                                      <p className="s impact">
                                        Min BER {item.minBerText}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="middle cell">
                              <p>
                                <span className="l">
                                  {this.state.calculationResult && (
                                    <NumberAsCurrency value={item.repayment} />
                                  )}
                                </span>
                              </p>
                            </div>
                            <div className="last cell">
                              <p>
                                {this.state.calculationResult &&
                                  item.rate + "%"}
                              </p>
                            </div>
                          </div>
                        </>
                      );
                    }
                  )}

                  {/* <div className="middlerow">
                      <div className="first cell">
                        <p>
                          {this.state.calculationResult &&
                            this.state.calculationResult.products.length > 1 &&
                            this.fixedYearText(
                              this.state.calculationResult.products[1]
                            )}
                        </p>
                      </div>
                      <div className="middle cell">
                        <p>
                          <span className="l">
                            {this.state.calculationResult &&
                              this.state.calculationResult.products.length >
                                1 && (
                                <NumberAsCurrency
                                  value={
                                    this.state.calculationResult.products[1]
                                      .repayment
                                  }
                                />
                              )}
                          </span>
                        </p>
                      </div>
                      <div className="last cell">
                        <p>
                          {this.state.calculationResult &&
                            this.state.calculationResult.products.length > 1 &&
                            this.state.calculationResult?.products[1].rate +
                              "%"}
                        </p>
                      </div>
                    </div>
                    <div className="lastrow">
                      <div className="first cell">
                        <p>
                          {this.state.calculationResult &&
                            this.state.calculationResult.products.length > 2 &&
                            this.fixedYearText(
                              this.state.calculationResult.products[2]
                            )}
                        </p>
                      </div>
                      <div className="middle cell">
                        <p>
                          <span className="l">
                            {this.state.calculationResult &&
                              this.state.calculationResult.products.length >
                                2 && (
                                <NumberAsCurrency
                                  value={
                                    this.state.calculationResult.products[2]
                                      .repayment
                                  }
                                />
                              )}
                          </span>
                        </p>
                      </div>
                      <div className="last cell">
                        <p>
                          {this.state.calculationResult &&
                            this.state.calculationResult.products.length > 2 &&
                            this.state.calculationResult?.products[2].rate +
                              "%"}
                        </p>
                      </div>
                    </div> */}
                </div>
                <div className="column1">
                  <div className="repayment-tile travertine">
                    <div className="column2 justify-s">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 0 &&
                          this.state.calculationResult?.products[0].rate + "%"}
                      </p>
                    </div>
                    <div className="column2d justify-e">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 0 && (
                            <>
                              {this.fixedYearText(
                                this.state.calculationResult?.products[0]
                              )}
                            </>
                          )}
                      </p>
                    </div>
                    <h1>
                      {this.state.calculationResult && (
                        <NumberAsCurrency
                          value={this.state.calculationResult.repayment}
                        />
                      )}
                    </h1>
                  </div>
                </div>
                <div className="column1">
                  <div className="repayment-tile teal">
                    <div className="column2 justify-s">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 1 &&
                          this.state.calculationResult?.products[1].rate + "%"}
                      </p>
                    </div>
                    <div className="column2d justify-e">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 1 && (
                            <>
                              {this.fixedYearText(
                                this.state.calculationResult?.products[1]
                              )}
                            </>
                          )}
                      </p>
                    </div>
                    <h1>
                      {this.state.calculationResult && (
                        <NumberAsCurrency
                          value={
                            this.state.calculationResult.products[1].repayment
                          }
                        />
                      )}
                    </h1>
                  </div>
                </div>
                <div className="column1">
                  <div className="repayment-tile teal">
                    <div className="column2 justify-s">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 2 &&
                          this.state.calculationResult?.products[2].rate + "%"}
                      </p>
                    </div>
                    <div className="column2d justify-e">
                      <p>
                        {this.state.calculationResult &&
                          this.state.calculationResult?.products.length > 2 && (
                            <>
                              {this.fixedYearText(
                                this.state.calculationResult?.products[2]
                              )}
                            </>
                          )}
                      </p>
                    </div>
                    <h1>
                      {this.state.calculationResult && (
                        <NumberAsCurrency
                          value={
                            this.state.calculationResult.products[2].repayment
                          }
                        />
                      )}
                    </h1>
                  </div>
                </div>
              </div>
              <div className="row mb-0">
                <p className="s">
                  Disclaimer: Our calculators give indicative figures and are
                  based on 35 year term unless another is selected. They are in
                  no way intended to constitute an offer. Such calculations are
                  made on the presumption that the information supplied by you
                  is accurate and is subject to approval by the actual lender.
                  Rates include Green rate options which only apply if BER is B3
                  or above. This web page is for illustrative purposes only, so
                  as to give you, the borrower, an overview of the potential
                  cost of borrowing.
                </p>
              </div>
            </div>
          )}
          {/* </div> */}
        </div>
      </header>
    );
  }
}
